import { FC } from 'react';
import { AppointmentProcedure } from '../../../../../../../../services/appointment/types';
import { StyledDataGrid } from '../../../../../../../shared/grid/grid.styles';
import { NoDataComponent } from '../../../../../../../shared/grid/no-data';
import { ProceduresTableColumns } from './procedures-table.columns';

export interface ProceduresTableProps {
  isLoading?: boolean;
  procedures: AppointmentProcedure[];
}

export const ProceduresTable: FC<ProceduresTableProps> = (props) => {
  const { procedures, isLoading } = props;

  return (
    <StyledDataGrid
      rows={procedures}
      columns={ProceduresTableColumns()}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 99 }
        },
        columns: {
          columnVisibilityModel: { id: false }
        }
      }}
      slots={{ noRowsOverlay: NoDataComponent }}
      disableRowSelectionOnClick
      rowHeight={56}
      autoHeight={true}
      columnHeaderHeight={26}
      disableColumnMenu={true}
      hideFooter={true}
      loading={isLoading}
      hideFooterSelectedRowCount={true}
      disableVirtualization
      sx={{
        marginTop: '30px',
        '--DataGrid-overlayHeight': '250px',
        color: 'black',
        cursor: 'default',
        '& .MuiDataGrid-virtualScroller': { overflow: 'hidden' }
      }}
    />
  );
};
